export const deliverySlipMappers = {
  mapDeliverySlip(data) {
    const mappedData = {
      ...data,
      sales_target:
        data.sales_target !== null ? Number(data.sales_target) : null
    };
    return mappedData;
  },
  mapDeliverySlipTemplate(data) {
    const mappedData = {
      ...data,
      sales_target:
        data.sales_target !== null ? Number(data.sales_target) : null
    };
    return mappedData;
  }
};
